import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';


import { castMagic } from 'Redux/ducks/auth';
import { history } from 'Redux/store';
import { toggleLoginModal } from 'Redux/ducks/modal';

const MagicLoginContainer = ({ match }) => {
  const dispatch = useDispatch();
  const { token } = match.params;
  const { magicSuccess, error, authenticated } = useSelector(state => state?.auth);

  useEffect(() => {
    dispatch(castMagic(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (authenticated) {
      history.push('/');
    }
  }, [authenticated]);

  useEffect(() => {
    if (magicSuccess) {
      setTimeout(() => {
        history.push('/');
      }, 2000);
    }
  }, [magicSuccess]);

  const handleModalToggle = () => {
    dispatch(toggleLoginModal());
  };

  return (
    <div className="text-center my-5">
      <div className="container">
        {error &&
        <React.Fragment>
          <h1 className="text-primary not-found-title">
            <FormattedMessage id="magic-login.header-error" defaultMessage="Magic sign in error" />
          </h1>
          <p>
            <FormattedMessage id="magic-login.paragraph-error" defaultMessage="Sorry but there was a problem with your magic sign in link. Please try and sign in again." />
          </p>
          <button type="button" className="btn btn-primary" onClick={handleModalToggle}>
            <FormattedMessage id="magic-login.button-sign-in" defaultMessage="SIGN IN" />
          </button>
        </React.Fragment>
          }
        {magicSuccess &&
        <React.Fragment>
          <h1 className="text-primary not-found-title">
            <FormattedMessage id="magic-login.header-success" defaultMessage="Magic sign in success" />
          </h1>
          <p>
            <FormattedMessage id="magic-login.paragraph-success" defaultMessage="We are now signing you in. You will be redirected shortly." />
          </p>
        </React.Fragment>
          }
      </div>
    </div>
  );
};


MagicLoginContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }),
};

MagicLoginContainer.defaultProps = {
  match: ({
    params: {
      token: '',
    },
  }),
};


export default MagicLoginContainer;
